export default __webpack_public_path__ + "static/media/forget_password.0bcc3641.svg";